import React from 'react';
import { Widget } from '@typeform/embed-react';

function StudentAmbassador() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div className="container">
        <div className='row rowpad1' data-aos="fade-up">
          <div className='col' style={{paddingTop: "20px", textAlign: "center"}}>
            <p className="maintitle">IRO Student Ambassador</p>
          </div>
        </div>
      </div>
      <div style={{ width: '100%', height: '100vh' }}>
        <Widget
          id="X9aTCTzd"
          style={{ width: '100%', height: '100vh' }}
        />
      </div>
    </div>
  );
}

export default StudentAmbassador;
